<template>
  <div class="bg-green-50 page-section pt-5 -mb-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 py-3 wow zoomIn">
          <div class="img-place text-center hidden lg:flex">
            <img src="../assets/image.png" alt="" style="width: 70%; height: auto;" />
          </div>
        </div>

        <div class="col-lg-6 p-4">
          <h2 class="title-section text-2xl">
            What's
            <span class="marked">AN&Digit</span>
          </h2>
          <div class="divider"></div>

          <div>
            <p>
              I am a
              freelancer in the field of data science and web development. I
              like to analyse data, create website and help people in their digital transition.
            </p>
            
          </div>
        </div>
      </div>
    </div>
    <!-- .container -->
  </div>
  <!-- .page-section -->

  <div class="bg-green-50 page-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 p-4 -mt-1 lg:mt-1">
          <h2 class="title-section text-2xl">
            Project
            <span class="marked">by AN&Digit</span>
          </h2>
          <div class="divider"></div>
        </div>

        <div class="">
      <div class="page-section bg-green-50">
        <div class="container">
          <div class="row my-5 card-blog-row">
            <div class="relative lg:hidden col-md-6 col-lg-3 py-3 wow fadeInUp">
              <div class="card-blog">

  
              </div>
            </div>
  
                <div
                  v-for="(a, i) in project"
                  :key="a"
                  class="col-md-5 col-lg-4 py-5 px-4"
                >
                  <div
                    class="flex flex-col space-y-5 border shadow-md border-green-500 bg-white h-96 rounded-md hover:-mt-1 hover:shadow-lg hover:shadow-green-200 cursor-pointer"
                  >
                    <div
                      class="flex items-center justify-center -mt-6 h-48 rounded-t-lg overflow-hidden"
                    >
                      <img class="h-48 w-96 rounded-t-lg" :src="project[i].image" />
                    </div>
      
                    <div class="flex flex-col ml-4">
                      <div class="text-xl font-medium text-green-600 ml-3 mb-2">
                        <a>{{ project[i].name }}</a>
                      </div>
                      <div
                        class="text-base h-18 lg:h-12 text-gray-700 ml-3 mr-3 mb-2"
                      >
                        {{ project[i].content }}
                      </div>
      
                      <!-- <div
                        class="flex flex-row items-start py-3 px-2 space-x-3 ml-2"
                        style="padding-bottom: 25px"
                      >
                        <img :src="project[i].tech1" />
                        <img :src="project[i].tech2" />
                        <img :src="project[i].tech3" />
                      </div> -->
                    </div>
                  </div>
                  <div class="mt-4 hover:underline">
                    <a
                      :href="project[i].live"
                      target="_blank"
                      class="btn text-lg hover:bg-green-100 hover:underline hover:font-medium"
                    >
                      Live
                      <span class="mai-chevron-forward text-sm"></span>
                    </a>
      
                    <a
                      :href="project[i].code"
                      target="_blank"
                      class="btn text-lg hover:bg-purple-100 hover:font-medium"
                    >
                      Source Code
                      <span class="mai-chevron-forward text-sm"></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <!-- .container -->
    <div class="bg-green-50 page-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 p-4 -mt-9 lg:mt-0">
          <h2 class="title-section text-2xl">
            Services Offered
            <span class="marked">by AN&Digit</span>
          </h2>
          <div class="divider"></div>
          <p class="mb-4">
            AN&Digit offers a wide range of services, including the development
            of AI tools, creating showcase websites and portfolios and data analysis.
          </p>
          <p class="mb-4">
            For more informations, please visit my Fiverr page or contact me
            directly.
          </p>

          <a
            href="https://fr.fiverr.com/adrie2_511"
            class="btn btn-outline ml-2"
          >
            Fiver link >
          </a>
        </div>
        <div class="col-lg-6 py-7 wow zoomIn">
          <div class="img-place text-center">
            <img src="../assets/Fiver.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    </div>

  <!-- FPV Drone Piloting & Video Content Creation Section -->
  <div class="bg-green-50 page-section pt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 p-4">
          <h2 class="title-section text-2xl">
            FPV Drone Piloting & Video Content Creation
          </h2>
          <div class="divider"></div>
          <p>
            I am skilled in FPV (First-Person View) drone piloting, allowing me to capture breathtaking aerial footage. My passion for drone technology and piloting enables me to create dynamic and captivating videos that leave a lasting impression.
          </p>
          <p>
            With expertise in video content creation, I produce compelling visuals for brands, stunning landscapes, or corporate events, delivering impactful videos tailored to your needs.
          </p>
        </div>

        <div class="col-lg-6 py-3">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <!-- Example Video 1 -->
            <div class="video-container">
              <iframe
                src="https://www.youtube.com/embed/7L6KvMlQB6U?si=eUZAJ22qiKbj-YJ0"
                title="FPV Aerial Shots"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                class="rounded-md shadow-md hover:shadow-lg transition-transform transform hover:scale-105"
              ></iframe>
            </div>

            <!-- Additional Example Videos -->
            <div v-for="video in videos" :key="video.id" class="video-container">
              <iframe
                :src="video.url"
                :title="video.title"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                class="rounded-md shadow-md hover:shadow-lg transition-transform transform hover:scale-105"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectData from "../data/portfolio.js";
export default {
  data() {
    return {
      scrollPosition: 0,
      project: ProjectData,
      videos: [
        {
          id: 1,
          url: "https://www.youtube.com/embed/UZETQyEil6U?si=xkZR4-1YCI-hgHvd",
          title: "FPV Aerial Shots",
        },
        {
          id: 2,
          url: "https://www.youtube.com/embed/cwME85Gf6Hg?si=CUPkf27W1ukm5BSA",
          title: "FPV Aerial Shots",
        },
        {
          id: 3,
          url: "https://www.youtube.com/embed/x_k5aWFCfwU?si=5t3sKaRqO7dK1Gke",
          title: "FPV Aerial Shots",
        },
      ],
    };
  },

  methods: {
    handleScroll(e) {
      this.scrollPosition = e.target.scrollTop;

      if (this.scrollPosition > 100) {
        console.log("UP");
      } else {
        console.log("DOWN");
      }
    },
  },
};
</script>

<style scoped>
img {
  width: 50vh;
  height: 50vh;
  object-fit: cover;
  object-position: center;
  border-radius: 10%;
}
.video-container {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
}

video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.zoomIn:hover {
  transform: scale(1.05);
  transition: all 0.5s ease;
}
</style>
